import {useEffect, useRef} from 'react';
import {useLogout} from '@/hooks/global-hooks/useLogout.js';

const Logout = () => {

    const {logout} = useLogout();
    const isLoggingOutRef = useRef(false);

    useEffect(() => {

        if (isLoggingOutRef.current) {
            return;
        } // Bloque les appels multiples
        isLoggingOutRef.current = true;

        const performLogout = async () => {

            try {
                await logout();
            } catch (error) {
                console.error('❌ Erreur dans le composant Logout:', error);
                // Redirection de secours
                window.location.href = '/';
            }
        };

        performLogout();
    }, [logout, isLoggingOutRef]);

    return null; // Aucune interface utilisateur n'est rendue
};

export default Logout;
